import { CreateOrderTemplate } from "@/components/Templates";
import { useCreateOrderPage } from "@/hooks/useCreateOrderPage";

export function CreateOrderPage() {
  const createOrder = useCreateOrderPage();

  return <CreateOrderTemplate {...createOrder} />;
}
